import { apiRequest } from './axiosConfig';

export interface HomeSummary {
  monthly_banner_count: number;
  monthly_video_count: number;
  product_count: number;
}

export const fetchHomeSummary = async (): Promise<HomeSummary> => {
  const response = await apiRequest.get<{ data: HomeSummary }>('home/summary');
  return response.data;
};
